




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PasswordFieldValidator extends Vue {
  @Prop() readonly value!: string;

  public getMessage (): string {
    if (this.value === undefined || this.value === null) {
      return '';
    }

    if (this.value.length < 6) {
      return 'Password must be 6 characters long';
    }

    if (!(/[A-Z]+/.test(this.value))) {
      return 'Password must contain at least one upper case character';
    }

    if (!(/[a-z]+/.test(this.value))) {
      return 'Password must contain at least one lower case character';
    }

    if (!(/[0-9]+/.test(this.value))) {
      return 'Password must contain at least one number';
    }

    if (!(/[$@#&!]+/.test(this.value))) {
      return 'Password must contain at least one symbol';
    }

    return '';
  }

  public getValidationClass (): string {
    return this.getMessage() === '' ? 'field-validation-valid' : 'field-validation-error';
  }
}
